import { defineComponent as _defineComponent } from 'vue'
import { useStore } from '@/store';
  import { computed, ref } from 'vue';
  import FontSelector from '@/components/common/fontSelector/FontSelector.vue';
  import BaseText from '@ui/atoms/baseText/BaseText.vue';
  import ColorPicker from '@/components/ColorPicker.vue';
  import {
    ViewerStyleBackground,
    ViewerStyleDeparture,
    ViewerStyleLine,
    ViewerStyleTitle,
  } from '@/types/widgets/trafiklabWidget/trafiklabWidget';
  import { debounce } from 'lodash';
  import { DEFAULT_TRAFIKLAB_VIEWER_STYLE } from '@/constant/trafiklabWidget';
  import BaseDivider from '@ui/atoms/baseDivider/BaseDivider.vue';
  import {
    getDefaultFontType,
    mergeTrafiklabViewerStyles,
  } from '@/helpers/widgets/trafiklabWidget/trafiklabWidget';

  
  const __default__ = {
    name: 'TrafiklabSettingPanel',
  };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    viewerStyles: { type: Object, required: true, default: {} },
    disabled: { type: Boolean, default: false },
  },
  emits: ["update:viewerStyles"],
  setup(__props, { emit }: { emit: ({
    (event: 'update:viewerStyles', viewerStyles: any): void;
  }), expose: any, slots: any, attrs: any }) {

const { viewerStyles } = __props;

  

  

  const store = useStore();

  const title = ref({
    fontType: getDefaultFontType(store.getters.userFonts, viewerStyles.title.fontType),
    fontColor: viewerStyles.title.fontColor,
    fontSize: viewerStyles.title?.fontSize ?? DEFAULT_TRAFIKLAB_VIEWER_STYLE.title.fontSize,
  } as ViewerStyleTitle);

  const content = ref({
    fontType: getDefaultFontType(store.getters.userFonts, viewerStyles.departures.fontType),
    fontColor: viewerStyles.departures.fontColor,
    fontSize:
      viewerStyles.departures?.fontSize ?? DEFAULT_TRAFIKLAB_VIEWER_STYLE.departures.fontSize,
  } as ViewerStyleDeparture);

  const line = ref({
    fontColor: viewerStyles?.line?.fontColor ?? DEFAULT_TRAFIKLAB_VIEWER_STYLE.line.fontColor,
    backgroundColor:
      viewerStyles?.line?.backgroundColor ?? DEFAULT_TRAFIKLAB_VIEWER_STYLE.line.backgroundColor,
  } as ViewerStyleLine);

  const background = ref({
    color: viewerStyles.background.color,
    transparency: viewerStyles.background.transparency,
  } as ViewerStyleBackground);

  const even = ref(viewerStyles.evenDeparturesBackground);
  const odd = ref(viewerStyles.oddDeparturesBackground);

  const fonts = computed(() => {
    return store.getters.userFonts;
  });

  function handleUpdate() {
    const _debounce = debounce(() => {
      const newViewerStyles = mergeTrafiklabViewerStyles(
        viewerStyles,
        title.value,
        content.value,
        line.value,
        background.value,
        even.value,
        odd.value,
      );

      emit('update:viewerStyles', newViewerStyles);
    }, 300);

    _debounce();
  }

return { __sfc: true,emit, store, title, content, line, background, even, odd, fonts, handleUpdate, FontSelector, BaseText, ColorPicker, BaseDivider }
}

})